module.exports = __webpack_public_path__ + "media/images/flags/64/New-Zealand-9e585fb9caa4f4050106147b1cfa93fb.png";